import React from 'react';
import { Box, Typography } from '@material-ui/core';

const NoCourseSelected = () => {
  return (
    <Box p={6} textAlign="center">
      <Typography variant="h6" color="textSecondary">
        No Course Selected
      </Typography>
    </Box>
  );
};

export default NoCourseSelected;
